import { defaultEditSlideMenuState } from '../../defaulState'
import { MENU } from '../constants'
import _ from 'lodash'


const menuReducer = (state = defaultEditSlideMenuState, action) => {
    let _newState = {};
    switch (action.type) {

        case MENU.PREVIEW_SLIDE:
            _newState = state
            _newState.previewSlide = true
            _newState.workspaceRandom = Date.now()
            break;

        case MENU.STOP_PREVIEW:
            _newState = state
            _newState.previewSlide = false
            _newState.workspaceRandom = Date.now()
            break;

        case MENU.SWITCH_EDIT_TEXT_PANEL:
            _newState = { ...state }
            if (Date.now() - _newState.toggleEditingTextPanelTime > 500) {

                _newState.editingText = action.payload
                _newState.toggleEditingTextPanelTime = Date.now()
                if (!action.payload) {
                    // если редактирование текста закрываем, то и font picker должен быть закрыт
                    _newState.fontPickerIsOpen = false
                    _newState.shadowPickerIsOpen = false
                }
            }
            break;

        case MENU.SHIFT_PRESS:
            _newState = state
            _newState.shiftIsPress = action.payload
            break;

        case MENU.CTRL_PRESS:
            _newState = state
            _newState.ctrlIsPress = action.payload
            break;

        case MENU.ADD_SELECTED_CAPTION:
            // распаковываю через spread, т.к. иначе в prevProps и this.props ссылка на один и тот же массив
            _newState = { ...state, captionSelectedArray: [...state.captionSelectedArray] }
            // на всякий случай проверка, если этот индекс уже добавлен, то не добавляем
            if (_newState.captionSelectedArray.find(i => i === action.payload) === undefined) {
                _newState.captionSelectedArray.push(action.payload)
            }
            break;

        case MENU.CHOOSE_ANOTHER_ONE_CAPTION:
            _newState = { ...state }
            _newState.captionSelectedArray = [action.payload]
            _newState.fontPickerIsOpen = false
            _newState.shadowPickerIsOpen = false
            _newState.editingText = false
            _newState.editingCaptionIndex = action.payload
            break;

        case MENU.UNSELECT_CAPTION:
            _newState = state
            _newState.captionSelectedArray.splice(action.payload, 1)
            _newState.editingCaptionIndex = _newState.captionSelectedArray.length > 0 ? _newState.captionSelectedArray[0] : null
            break;

        case MENU.ADD_ALL_CAPTIONS:
            _newState = state
            // если во время выбора всех капч ни одна не выбрана главной, то выбираем самую первую
            // if (_newState.editingCaptionIndex === null) {
            _newState.editingCaptionIndex = action.payload.length > 0 ? action.payload[0] : null
            // }
            _newState.captionSelectedArray = action.payload
            break;

        case MENU.ADD_SOME_CAPTIONS:
            _newState = { ...state }
            _newState.captionSelectedArray = action.payload
            _newState.editingCaptionIndex = action.payload.length > 0 ? action.payload[0] : null
            break;

        case MENU.COPY_CAPTIONS:
            _newState = state
            const captionsToCopy = action.payload.copyCaptions
            const captionsArray = []
            for (let caption of captionsToCopy) {
                const captionClone = _.cloneDeep(caption)
                if (captionClone.boxId) {
                    const boxIndex = _.findIndex(captionsToCopy, { id: captionClone.boxId })
                    if (boxIndex === -1) {
                        captionClone.boxId = ''
                    }
                } else if (captionClone.type === 'box') {
                    const boxChildren = action.payload.allCaptions.filter(c => c.boxId === captionClone.id)
                    for (let child of boxChildren) {
                        if (_.findIndex(captionsToCopy, { id: child.id }) === -1) {
                            captionsArray.push(_.cloneDeep(child))
                        }
                    }
                }
                captionsArray.push(captionClone)
            }
            sessionStorage.setItem('copy-captions-text-slider', JSON.stringify(captionsArray))

            _newState.copyCaptions = captionsArray
            break;

        case MENU.CLEAR_SELECTED_CAPTION:
            // распаковал спредом, иначе prevProps и this.props ссылаются на один и тот же массив
            _newState = { ...state }
            _newState.captionSelectedArray = []
            _newState.fontPickerIsOpen = false
            _newState.shadowPickerIsOpen = false
            _newState.editingText = false
            // поставил null чтобы не висел никакой индекс, когда ни одна капча не выделена
            // нужно для сравнения индексов, когда происходит новое выделение
            _newState.editingCaptionIndex = null
            break;

        case MENU.CHANGE_GRID:
            _newState = state
            _newState.gridOn = action.payload
            break;

        case MENU.CHANGE_RULERS:
            _newState = state
            _newState.rulers = action.payload
            break;

        case MENU.CHANGE_PIPETT:
            _newState = state
            _newState.pipettOn = action.payload
            break;

        case MENU.INIT_SAVED_RULERS:
            _newState = state
            _newState.rulersArray = action.payload.rulersArray
            _newState.rulersArrayMobile = action.payload.rulersArrayMobile
            break;

        case MENU.ADD_RULER:
            _newState = _.cloneDeep(state)
            if (_newState.viewType === 'mobile') {
                _newState.rulersArrayMobile.push(action.payload)
            } else {
                _newState.rulersArray.push(action.payload)
            }
            break;

        case MENU.DELETE_RULER:
            _newState = state
            if (action.payload === 'all') {
                _newState.rulersArrayMobile = []
                _newState.rulersArray = []
            } else {
                if (_newState.viewType === 'mobile') {

                    _newState.rulersArrayMobile.splice(action.payload, 1)
                } else {
                    _newState.rulersArray.splice(action.payload, 1)
                }
            }

            break;

        case MENU.CHANGE_RULER_POSITION:
            _newState = state
            if (_newState.viewType === 'mobile') {
                _newState.rulersArrayMobile[action.payload.id].position = action.payload.position
            } else {
                _newState.rulersArray[action.payload.id].position = action.payload.position
            }
            break;

        case MENU.CHANGE_VIEW_TYPE:
            _newState = state
            _newState.viewType = action.payload
            _newState.workspaceRandom = Date.now()
            break;

        case MENU.CHANGE_EDITING_CAPTION_INDEX:
            _newState = state
            // _newState.captionSelectedArray = [action.payload]
            _newState.editingCaptionIndex = action.payload
            break;

        case MENU.OPEN_FONT_PICKER:
            _newState = state
            _newState.fontPickerIsOpen = action.payload
            break;

        case MENU.OPEN_SHADOW_PICKER:
            _newState = state
            _newState.shadowPickerIsOpen = action.payload
            break;

        case MENU.CHANGE_FONT_PICKER_POSITION:
            _newState = state
            _newState.fontPickerPosition = action.payload
            break;

        case MENU.CHANGE_SHADOW_PICKER_POSITION:
            _newState = state
            _newState.shadowPickerPosition = action.payload
            break;

        case MENU.CHANGE_BOX_FIGURE_IS_EDIT:
            _newState = state
            _newState.boxFigureIsEdit = action.payload
            break;

        case MENU.CHANGE_MOBILE_VIEW_SCALE:
            _newState = state
            _newState.mobileViewScale = action.payload
            break;

        case MENU.UPDATE_WORKSPACE_RANDOM:
            _newState = state
            _newState.workspaceRandom = Date.now()
            break;

        case MENU.SET_UNIC_CLASSNAME:
            _newState = state
            _newState.unicClassName = action.payload
            break;

        case MENU.SAVE_TEMP_STYLE:
            _newState = _.cloneDeep(state);
            _newState.tempStyle = action.payload
            break;

        case MENU.TOGGLE_IMAGE_CROP:
            _newState = _.cloneDeep(state);
            _newState.isImageCrop = action.payload
            break;

        case MENU.VIDEO_TUTORIAL_ACTIVE:
            _newState = _.cloneDeep(state);
            _newState.showedVideo = !_newState.showedVideo
            break;

        case 'TOGGLE_EDITING_TEXT':
            _newState = _.cloneDeep(state);
            _newState.editingText = false
            break;

        case MENU.DROPDOWN_IS_OPEN:
            _newState = _.cloneDeep(state);
            _newState.dropdownIsOpen = action.payload
            break;
        case MENU.TOGGLE_ICON_MODAL:
            _newState = _.cloneDeep(state);
            _newState.iconModalOn = !_newState.iconModalOn
            break;
        case MENU.TOGGLE_SVG_MODAL:
            _newState = _.cloneDeep(state);
            _newState.svgModalOn = !_newState.svgModalOn
            break;
        case MENU.IMAGE_CAPTION_CROP:
            _newState = _.cloneDeep(state);
            _newState.imageCaptionCropModal = !_newState.imageCaptionCropModal
            _newState.imageCaptionCropIndex = action.payload

            break;
        default:
            _newState = state
    }

    return _newState

}


export { menuReducer }